<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="12" class="pa-0">
      <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Suche"
        single-line
        hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
      :headers="headers"
      hide-default-footer
      :items-per-page="-1"
      :items="deviceList"
      :search="search"
      >

        <template v-slot:item.allowed="{ item }">
             <v-icon
                     small
                     class="mx-2"
                     @click="openEditor(item)"
             >
              edit
            </v-icon>
          <!--
          <span>
            <v-checkbox outlined v-model="item.allowed" class="mx-2" label="Zugeteilt" readonly></v-checkbox>
          </span>
          -->
        </template>

        <template v-slot:item.name="{ item }">
          <span @click="openEditor(item)">
            {{item.name}}
          </span>
        </template>
      </v-data-table>
      <v-col cols="12" class="text-right">
        <v-btn @click="createItem()">Recht erstellen</v-btn>
      </v-col>
    </v-card>
    </v-col>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

export default {
  name: 'TableGeneralRechte',
  props: {
    showTitle: Boolean,
    companyId: String
  },
  components: {DialogDeleteItem},
  methods: {
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Recht',
        id: '' + item.guid,
        name: 'Recht ' + item.username,
        item: item
      })
    },
    createItem: function () {
      console.log('createItem')
      this.$router.push('/Rechte/' + 'NewItem')
      /*
      Vue.prototype.$apiCompany.createCompany({
        isMother: 1
      }, this.onCompanyCreated)
       */
    },
    onItemCreated: function (item) {
      console.log('onItemCreated', item)
      this.$router.push('/Rechte/' + item.guid)
    },
    openEditor: function (item) {
      this.$router.push('/Rechte/' + item.guid)
    },
    doDelete: function (item) {
      console.log('item', item)
      Vue.prototype.$apiRight.deleteItem(item.item.guid, this.reload)
    },
    changeRight: function (item) {
      console.log('changeRight', item)
      var allowed = 0
      if (item.allowed) allowed = 1
      var up = {
        guid: item.guid,
        allowed: allowed
      }
      Vue.prototype.$apiRight.updateItem(up.guid,up, this.reload)
    },
    reload: function () {
      var reqData = {}
      if (this.roleId != null) {
        reqData.guidParent = this.roleId
      }
      Vue.prototype.$apiRight.loadRights(reqData, this.onGetData)
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  data () {
    return {

      currentDevice: null,
      search: null,
      roleId: 'DEFAULT_ALL',
      headers: [
        {text: 'Erlaubt', align: 'left', value: 'allowed'},
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Gruppe', value: 'groupName'},
        {text: 'Beschreibung', value: 'comment'}
      ],
      deviceList: []
    }
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })

  }
}
</script>

<style scoped>

</style>
